module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2sIL1T/tc-custom/9781460338643.jpg?1718078526812",
      "alt": "This image is the cover for the book Changing Constantinou's Game"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Changing Constantinou's Game\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One kiss couldn't hurt, could it?")]), _c('b'), _c('br'), _c('br'), _vm._v("Alexios Constantinou is notorious for his lethal charm, so when the exquisite Isabel Peters isliterallydropped into his lap during a hellish elevator ride, he doesn't waste the opportunity! With tensions sky-high after their near-death experience, an insatiable desire ignites between them, and all bets are off. "), _c('br'), _c('br'), _vm._v("But when Alex discovers that reporter Isabel's next story is him, he's furiousyet determined to use it to his advantage. He's calling the shots, but the closer Isabel gets, the closer she comes to discovering his carefully concealed secret. Now, with everything at stake, he'll need a whole new game plan.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Hayward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0